export const percentageValue = (value: number, total: number, progress: number) => {
  if (total === 0) {
    return 0;
  }
  return (value / total) * 100 * progress;
};

